// src/utils/reporteTasasGenerator.js

// Configuración de SYSTEM JJ para reportes
export const SYSTEM_JJ_CONFIG = {
  nombre: "SYSTEM JJ",
  rif: "J-405678901",
  direccion: "C.C. LATIN CENTER PB LOCAL 01",
  telefono: "0416-7594723",
  whatsapp: "04167594723",
  ciudad: "ACARIGUA - PORTUGUESA",
  email: "soporte@systemjj.com",
  sitioWeb: "www.systemjj.com",
  slogan: "Servicio Técnico Especializado",
  lema: "Tecnología al servicio de la gente"
};

// Variable para el logo en base64
let LOGO_BASE64 = '';

// Función para cargar el logo automáticamente
export const cargarLogo = async () => {
  try {
    const response = await fetch('/jj.png');
    const blob = await response.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        LOGO_BASE64 = reader.result.split(',')[1];
        resolve(LOGO_BASE64);
      };
      reader.onerror = () => {
        LOGO_BASE64 = '';
        resolve('');
      };
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error('Error cargando el logo:', error);
    LOGO_BASE64 = '';
    return '';
  }
};

// Función para obtener el logo actual
export const getLogoBase64 = () => LOGO_BASE64;

// Formatear fecha para reporte
export const formatearFechaReporte = (fechaISO) => {
  if (!fechaISO) return 'No disponible';
  try {
    const fecha = new Date(fechaISO);
    return fecha.toLocaleDateString('es-VE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch {
    return fechaISO;
  }
};

// Formatear fecha corta
export const formatearFechaCorta = (fechaISO) => {
  if (!fechaISO) return 'No disponible';
  try {
    const fecha = new Date(fechaISO);
    return fecha.toLocaleDateString('es-VE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  } catch {
    return fechaISO;
  }
};

// Formatear monto en bolívares
export const formatearMonto = (monto, decimales = 2) => {
  if (monto === null || monto === undefined || isNaN(monto)) return '0.00';
  return new Intl.NumberFormat('es-VE', {
    minimumFractionDigits: decimales,
    maximumFractionDigits: decimales
  }).format(monto);
};

// Convertir estado a texto legible
export const convertirEstadoTexto = (estado) => {
  if (estado === true || estado === 'true' || estado === 1 || estado === '1') return 'ACTIVA';
  if (estado === false || estado === 'false' || estado === 0 || estado === '0') return 'INACTIVA';
  return estado ? estado.toString().toUpperCase() : 'DESCONOCIDO';
};

// Calcular estadísticas
export const calcularEstadisticasReporte = (tasas, tipo = 'compra') => {
  const total = tasas.length;
  const activas = tasas.filter(t => t.activa === true).length;
  const inactivas = tasas.filter(t => t.activa === false).length;
  
  // Agrupar por fuente
  const fuentesMap = {};
  tasas.forEach(tasa => {
    const fuente = tasa.nombreFuente || 'Sin fuente';
    if (!fuentesMap[fuente]) {
      fuentesMap[fuente] = {
        nombre: fuente,
        total: 0,
        activas: 0,
        precioPromedio: 0,
        sumaPrecios: 0
      };
    }
    fuentesMap[fuente].total++;
    if (tasa.activa) fuentesMap[fuente].activas++;
    
    const precio = tipo === 'compra' ? tasa.precio_usdt_bs : tasa.precio_usd_bs;
    fuentesMap[fuente].sumaPrecios += precio || 0;
  });
  
  // Calcular promedios por fuente
  Object.values(fuentesMap).forEach(fuente => {
    fuente.precioPromedio = fuente.total > 0 ? fuente.sumaPrecios / fuente.total : 0;
  });
  
  // Precios
  const precios = tasas.map(t => tipo === 'compra' ? t.precio_usdt_bs : t.precio_usd_bs).filter(p => p > 0);
  const precioMaximo = precios.length > 0 ? Math.max(...precios) : 0;
  const precioMinimo = precios.length > 0 ? Math.min(...precios) : 0;
  const precioPromedio = precios.length > 0 ? precios.reduce((a, b) => a + b, 0) / precios.length : 0;
  
  // Fuentes únicas
  const fuentesUnicas = Object.keys(fuentesMap).length;
  const fuentesActivas = Object.values(fuentesMap).filter(f => f.activas > 0).length;
  
  // Fechas
  const fechas = tasas
    .map(t => t.fecha)
    .filter(f => f)
    .map(f => new Date(f));
  
  const fechaMasAntigua = fechas.length > 0 
    ? new Date(Math.min(...fechas.map(f => f.getTime())))
    : null;
    
  const fechaMasReciente = fechas.length > 0 
    ? new Date(Math.max(...fechas.map(f => f.getTime())))
    : null;
  
  // Tasas recientes
  const sieteDiasAtras = new Date();
  sieteDiasAtras.setDate(sieteDiasAtras.getDate() - 7);
  const recientes = tasas.filter(t => {
    try {
      return new Date(t.fecha) >= sieteDiasAtras;
    } catch {
      return false;
    }
  }).length;
  
  return {
    total,
    activas,
    inactivas,
    porcentajeActivas: total > 0 ? Math.round((activas / total) * 100) : 0,
    porcentajeInactivas: total > 0 ? Math.round((inactivas / total) * 100) : 0,
    fuentesUnicas,
    fuentesActivas,
    fuentesDetalle: Object.values(fuentesMap).sort((a, b) => b.total - a.total),
    precioMaximo,
    precioMinimo,
    precioPromedio,
    recientes,
    fechaMasAntigua: fechaMasAntigua ? formatearFechaCorta(fechaMasAntigua.toISOString()) : 'N/A',
    fechaMasReciente: fechaMasReciente ? formatearFechaCorta(fechaMasReciente.toISOString()) : 'N/A'
  };
};

/**
 * Generar HTML del reporte de tasas - VERSIÓN BLANCO Y NEGRO PROFESIONAL
 */
export const generarHTMLReporteTasas = (tasas, tipo = 'compra', titulo = null, filtros = {}) => {
  const fechaActual = new Date();
  const estadisticas = calcularEstadisticasReporte(tasas, tipo);
  
  const tituloReal = titulo || `REPORTE DE TASAS DE ${tipo === 'compra' ? 'COMPRA (USDT → Bs)' : 'VENTA (USD → Bs)'}`;
  
  // Construir texto de filtros aplicados
  const filtrosAplicados = [];
  if (filtros.estado && filtros.estado !== 'todas') {
    filtrosAplicados.push(`Estado: ${filtros.estado === 'activas' ? 'ACTIVAS' : 'INACTIVAS'}`);
  }
  if (filtros.fuente) {
    filtrosAplicados.push(`Fuente: ${filtros.fuente}`);
  }
  if (filtros.busqueda && filtros.busqueda.trim()) {
    filtrosAplicados.push(`Búsqueda: "${filtros.busqueda}"`);
  }
  if (filtros.orden) {
    const ordenMap = {
      'fecha_desc': 'Más recientes',
      'fecha': 'Más antiguas',
      'fuente': 'Fuente (A-Z)',
      'precio_desc': 'Mayor precio',
      'precio': 'Menor precio'
    };
    filtrosAplicados.push(`Orden: ${ordenMap[filtros.orden] || filtros.orden}`);
  }
  
  const textoFiltros = filtrosAplicados.length > 0 
    ? `Filtros: ${filtrosAplicados.join(' | ')}` 
    : 'Sin filtros aplicados';

  return `
    <!DOCTYPE html>
    <html lang="es">
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>${tituloReal} - ${SYSTEM_JJ_CONFIG.nombre}</title>
      <style>
        /* ===== ESTILOS PROFESIONALES BLANCO Y NEGRO ===== */
        
        /* Reset y estilos base */
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }
        
        body {
          font-family: 'Arial', 'Helvetica', sans-serif;
          background: #f5f5f5;
          color: #333;
          line-height: 1.4;
          margin: 0;
          padding: 20px;
        }
        
        /* Contenedor principal */
        .reporte-container {
          max-width: 1400px;
          margin: 0 auto;
          background: white;
          box-shadow: 0 4px 20px rgba(0,0,0,0.1);
        }
        
        /* ===== HEADER PROFESIONAL ===== */
        .reporte-header {
          background: white;
          padding: 25px 30px;
          border-bottom: 2px solid #000;
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 20px;
        }
        
        .logo-area {
          display: flex;
          align-items: center;
          gap: 20px;
        }
        
        .logo-img {
          height: 70px;
          width: auto;
          border: 1px solid #ddd;
          padding: 5px;
          background: white;
        }
        
        .empresa-info-header {
          border-left: 2px solid #000;
          padding-left: 20px;
        }
        
        .empresa-nombre {
          font-size: 24px;
          font-weight: bold;
          color: #000;
          letter-spacing: 1px;
          margin-bottom: 5px;
        }
        
        .empresa-slogan {
          font-size: 12px;
          color: #666;
          text-transform: uppercase;
        }
        
        .rif-info {
          text-align: right;
          font-size: 12px;
          color: #666;
          line-height: 1.5;
        }
        
        .rif-info strong {
          color: #000;
        }
        
        /* ===== TÍTULO DEL REPORTE ===== */
        .titulo-reporte {
          padding: 20px 30px;
          background: #f8f8f8;
          border-bottom: 1px solid #ddd;
        }
        
        .titulo-reporte h1 {
          font-size: 22px;
          color: #000;
          font-weight: bold;
          margin-bottom: 5px;
        }
        
        .titulo-reporte p {
          font-size: 13px;
          color: #666;
        }
        
        .fecha-generacion {
          margin-top: 10px;
          font-size: 12px;
          color: #999;
        }
        
        /* ===== FILTROS APLICADOS ===== */
        .filtros-aplicados {
          padding: 12px 30px;
          background: #f0f0f0;
          border-bottom: 1px solid #ddd;
          font-size: 12px;
          color: #333;
        }
        
        .filtros-aplicados strong {
          color: #000;
        }
        
        /* ===== TARJETAS DE ESTADÍSTICAS ===== */
        .estadisticas-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 15px;
          padding: 25px 30px;
          background: white;
        }
        
        .estadistica-card {
          background: #f8f8f8;
          border: 1px solid #ddd;
          padding: 15px;
          text-align: center;
        }
        
        .estadistica-valor {
          font-size: 28px;
          font-weight: bold;
          color: #000;
          line-height: 1.2;
        }
        
        .estadistica-etiqueta {
          font-size: 11px;
          color: #666;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          margin-top: 5px;
        }
        
        .estadistica-detalle {
          font-size: 10px;
          color: #999;
          margin-top: 5px;
        }
        
        /* ===== BARRAS DE PROGRESO ===== */
        .barras-estado {
          padding: 0 30px 25px;
        }
        
        .barra-container {
          margin-bottom: 15px;
        }
        
        .barra-label {
          display: flex;
          justify-content: space-between;
          font-size: 12px;
          color: #333;
          margin-bottom: 5px;
        }
        
        .barra-fondo {
          background: #eee;
          height: 24px;
          border: 1px solid #ccc;
        }
        
        .barra-progreso {
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          padding-right: 10px;
          color: white;
          font-size: 11px;
          font-weight: bold;
          background: #333;
        }
        
        /* ===== SECCIONES ===== */
        .seccion {
          padding: 0 30px 30px;
        }
        
        .seccion h2 {
          font-size: 16px;
          color: #000;
          font-weight: bold;
          margin-bottom: 15px;
          padding-bottom: 8px;
          border-bottom: 2px solid #000;
        }
        
        /* ===== TABLA DE FUENTES ===== */
        .fuentes-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 15px;
        }
        
        .fuente-card {
          background: #f8f8f8;
          border: 1px solid #ddd;
          padding: 12px;
        }
        
        .fuente-nombre {
          font-weight: bold;
          font-size: 14px;
          color: #000;
          margin-bottom: 8px;
          padding-bottom: 5px;
          border-bottom: 1px solid #ddd;
        }
        
        .fuente-stats {
          display: flex;
          justify-content: space-between;
          font-size: 11px;
          color: #666;
          margin-bottom: 8px;
        }
        
        .fuente-precio {
          font-size: 16px;
          font-weight: bold;
          color: #000;
          text-align: right;
        }
        
        /* ===== TABLA PRINCIPAL ===== */
        .tabla-container {
          overflow-x: auto;
        }
        
        table {
          width: 100%;
          border-collapse: collapse;
          font-size: 11px;
          border: 1px solid #ddd;
        }
        
        th {
          background: #333;
          color: white;
          font-weight: 600;
          padding: 10px 8px;
          text-align: left;
          font-size: 10px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
        
        td {
          padding: 8px;
          border-bottom: 1px solid #ddd;
        }
        
        tr:last-child td {
          border-bottom: none;
        }
        
        tr:hover td {
          background: #f5f5f5;
        }
        
        /* Badges */
        .estado-badge {
          display: inline-block;
          padding: 4px 8px;
          font-size: 9px;
          font-weight: bold;
          text-transform: uppercase;
          border: 1px solid;
        }
        
        .estado-activo {
          background: white;
          color: #000;
          border-color: #000;
        }
        
        .estado-inactivo {
          background: white;
          color: #666;
          border-color: #ccc;
        }
        
        .fuente-badge {
          display: inline-block;
          padding: 4px 8px;
          background: #f0f0f0;
          color: #333;
          font-size: 9px;
          font-weight: bold;
          border: 1px solid #ccc;
        }
        
        .precio-cell {
          font-weight: bold;
          color: #000;
        }
        
        /* ===== RESUMEN FINAL ===== */
        .resumen-final {
          background: #f8f8f8;
          padding: 20px 30px;
          border-top: 2px solid #000;
          border-bottom: 2px solid #000;
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 20px;
        }
        
        .resumen-item {
          text-align: center;
        }
        
        .resumen-item .label {
          font-size: 10px;
          color: #666;
          text-transform: uppercase;
          margin-bottom: 5px;
        }
        
        .resumen-item .valor {
          font-size: 14px;
          font-weight: bold;
          color: #000;
        }
        
        /* ===== FOOTER ===== */
        .reporte-footer {
          background: #333;
          color: white;
          padding: 20px 30px;
          text-align: center;
          font-size: 10px;
        }
        
        .footer-info {
          display: flex;
          justify-content: center;
          gap: 30px;
          margin-bottom: 10px;
          flex-wrap: wrap;
        }
        
        .footer-info span {
          color: #ccc;
        }
        
        .copyright {
          color: #999;
          margin-top: 10px;
        }
        
        /* ===== BOTONES DE CONTROL ===== */
        .controles-impresion {
          padding: 20px 30px;
          text-align: center;
          background: white;
          border-top: 1px solid #ddd;
        }
        
        .btn-imprimir, .btn-cerrar {
          padding: 10px 30px;
          font-size: 12px;
          font-weight: bold;
          text-transform: uppercase;
          cursor: pointer;
          border: none;
          transition: all 0.3s;
        }
        
        .btn-imprimir {
          background: #333;
          color: white;
          border: 2px solid #333;
        }
        
        .btn-imprimir:hover {
          background: white;
          color: #333;
        }
        
        .btn-cerrar {
          background: white;
          color: #333;
          border: 2px solid #ccc;
          margin-left: 10px;
        }
        
        .btn-cerrar:hover {
          background: #f0f0f0;
        }
        
        /* Utilidades */
        .text-right {
          text-align: right;
        }
        
        .text-center {
          text-align: center;
        }
        
        .font-bold {
          font-weight: bold;
        }
        
        /* Media queries para impresión */
        @media print {
          body {
            background: white;
            padding: 0;
          }
          
          .reporte-container {
            box-shadow: none;
          }
          
          .no-print {
            display: none !important;
          }
          
          .controles-impresion {
            display: none;
          }
          
          @page {
            margin: 1.5cm;
            size: letter landscape;
          }
        }
      </style>
    </head>
    <body>
      <div class="reporte-container">
        <!-- HEADER PROFESIONAL con logo en esquina -->
        <div class="reporte-header">
          <div class="logo-area">
            <img src="data:image/jpeg;base64,${getLogoBase64()}" 
                 alt="SYSTEM JJ Logo" 
                 class="logo-img"
                 onerror="this.style.display='none'">
            <div class="empresa-info-header">
              <div class="empresa-nombre">${SYSTEM_JJ_CONFIG.nombre}</div>
              <div class="empresa-slogan">${SYSTEM_JJ_CONFIG.slogan}</div>
            </div>
          </div>
          <div class="rif-info">
            <strong>RIF:</strong> ${SYSTEM_JJ_CONFIG.rif}<br>
            <strong>${SYSTEM_JJ_CONFIG.ciudad}</strong>
          </div>
        </div>
        
        <!-- TÍTULO DEL REPORTE -->
        <div class="titulo-reporte">
          <h1>${tituloReal}</h1>
          <p>${SYSTEM_JJ_CONFIG.lema}</p>
          <div class="fecha-generacion">
            Generado: ${formatearFechaReporte(fechaActual.toISOString())}
          </div>
        </div>
        
        <!-- FILTROS APLICADOS -->
        <div class="filtros-aplicados">
          <strong>FILTROS:</strong> ${textoFiltros}
        </div>
        
        <!-- ESTADÍSTICAS -->
        <div class="estadisticas-grid">
          <div class="estadistica-card">
            <div class="estadistica-valor">${estadisticas.total}</div>
            <div class="estadistica-etiqueta">Total Tasas</div>
          </div>
          
          <div class="estadistica-card">
            <div class="estadistica-valor">${estadisticas.activas}</div>
            <div class="estadistica-etiqueta">Activas</div>
            <div class="estadistica-detalle">${estadisticas.porcentajeActivas}%</div>
          </div>
          
          <div class="estadistica-card">
            <div class="estadistica-valor">${estadisticas.inactivas}</div>
            <div class="estadistica-etiqueta">Inactivas</div>
            <div class="estadistica-detalle">${estadisticas.porcentajeInactivas}%</div>
          </div>
          
          <div class="estadistica-card">
            <div class="estadistica-valor">${estadisticas.fuentesUnicas}</div>
            <div class="estadistica-etiqueta">Fuentes</div>
          </div>
          
          <div class="estadistica-card">
            <div class="estadistica-valor">${formatearMonto(estadisticas.precioPromedio)}</div>
            <div class="estadistica-etiqueta">Precio Prom.</div>
          </div>
          
          <div class="estadistica-card">
            <div class="estadistica-valor">${estadisticas.recientes}</div>
            <div class="estadistica-etiqueta">Últimos 7d</div>
          </div>
        </div>
        
        <!-- BARRAS DE PROGRESO -->
        <div class="barras-estado">
          <div class="barra-container">
            <div class="barra-label">
              <span>Tasas Activas</span>
              <span>${estadisticas.activas} (${estadisticas.porcentajeActivas}%)</span>
            </div>
            <div class="barra-fondo">
              <div class="barra-progreso" style="width: ${estadisticas.porcentajeActivas}%">
                ${estadisticas.porcentajeActivas}%
              </div>
            </div>
          </div>
          
          <div class="barra-container">
            <div class="barra-label">
              <span>Tasas Inactivas</span>
              <span>${estadisticas.inactivas} (${estadisticas.porcentajeInactivas}%)</span>
            </div>
            <div class="barra-fondo">
              <div class="barra-progreso" style="width: ${estadisticas.porcentajeInactivas}%">
                ${estadisticas.porcentajeInactivas}%
              </div>
            </div>
          </div>
        </div>
        
        <!-- TABLA DE FUENTES -->
        ${estadisticas.fuentesDetalle.length > 0 ? `
        <div class="seccion">
          <h2>DETALLE POR FUENTE</h2>
          <div class="fuentes-grid">
            ${estadisticas.fuentesDetalle.map(fuente => `
              <div class="fuente-card">
                <div class="fuente-nombre">${fuente.nombre}</div>
                <div class="fuente-stats">
                  <span>Total: ${fuente.total}</span>
                  <span>Activas: ${fuente.activas}</span>
                </div>
                <div class="fuente-precio">
                  ${formatearMonto(fuente.precioPromedio)} Bs
                </div>
              </div>
            `).join('')}
          </div>
        </div>
        ` : ''}
        
        <!-- TABLA DE TASAS -->
        <div class="seccion">
          <h2>LISTADO DE TASAS DE ${tipo === 'compra' ? 'COMPRA (USDT → Bs)' : 'VENTA (USD → Bs)'}</h2>
          <div class="tabla-container">
            ${tasas.length > 0 ? `
            <table>
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Fuente</th>
                  <th>Precio (Bs)</th>
                  ${tipo === 'venta' ? '<th>Tasa Inversa</th>' : ''}
                  <th>Estado</th>
                  <th>Observaciones</th>
                </tr>
              </thead>
              <tbody>
                ${tasas.map(tasa => {
                  const precio = tipo === 'compra' ? tasa.precio_usdt_bs : tasa.precio_usd_bs;
                  return `
                    <tr>
                      <td>${formatearFechaCorta(tasa.fecha)}</td>
                      <td>
                        <span class="fuente-badge">${tasa.nombreFuente || 'N/A'}</span>
                      </td>
                      <td class="precio-cell">${formatearMonto(precio)} Bs</td>
                      ${tipo === 'venta' ? `<td>1 USD = ${formatearMonto(1 / precio, 4)} Bs</td>` : ''}
                      <td>
                        <span class="estado-badge ${tasa.activa ? 'estado-activo' : 'estado-inactivo'}">
                          ${convertirEstadoTexto(tasa.activa)}
                        </span>
                      </td>
                      <td>${tasa.observaciones || '—'}</td>
                    </tr>
                  `;
                }).join('')}
              </tbody>
            </table>
            ` : `
              <div style="text-align: center; padding: 60px; background: #f8f8f8; border: 1px solid #ddd;">
                <p style="font-size: 14px; color: #666;">No hay tasas para mostrar</p>
              </div>
            `}
          </div>
        </div>
        
        <!-- RESUMEN FINAL -->
        <div class="resumen-final">
          <div class="resumen-item">
            <div class="label">Tasa más antigua</div>
            <div class="valor">${estadisticas.fechaMasAntigua}</div>
          </div>
          <div class="resumen-item">
            <div class="label">Tasa más reciente</div>
            <div class="valor">${estadisticas.fechaMasReciente}</div>
          </div>
          <div class="resumen-item">
            <div class="label">Precio mínimo</div>
            <div class="valor">${formatearMonto(estadisticas.precioMinimo)} Bs</div>
          </div>
          <div class="resumen-item">
            <div class="label">Precio máximo</div>
            <div class="valor">${formatearMonto(estadisticas.precioMaximo)} Bs</div>
          </div>
        </div>
        
        <!-- FOOTER -->
        <div class="reporte-footer">
          <div class="footer-info">
            <span>${SYSTEM_JJ_CONFIG.direccion}</span>
            <span>Tel: ${SYSTEM_JJ_CONFIG.telefono}</span>
            <span>Email: ${SYSTEM_JJ_CONFIG.email}</span>
          </div>
          <div>RIF ${SYSTEM_JJ_CONFIG.rif} - ${SYSTEM_JJ_CONFIG.ciudad}</div>
          <div class="copyright">
            © ${new Date().getFullYear()} ${SYSTEM_JJ_CONFIG.nombre}
          </div>
        </div>
        
        <!-- CONTROLES DE IMPRESIÓN -->
        <div class="controles-impresion no-print">
          <button class="btn-imprimir" onclick="window.print()">IMPRIMIR</button>
          <button class="btn-cerrar" onclick="window.close()">CERRAR</button>
        </div>
      </div>
    </body>
    </html>
  `;
};

/**
 * Generar reporte simplificado - VERSIÓN BLANCO Y NEGRO
 */
export const generarHTMLReporteSimplificado = (tasas, tipo = 'compra', titulo = null) => {
  const fechaActual = new Date();
  const tituloReal = titulo || `LISTADO DE TASAS DE ${tipo === 'compra' ? 'COMPRA' : 'VENTA'}`;
  
  const activas = tasas.filter(t => t.activa === true).length;
  const inactivas = tasas.filter(t => t.activa === false).length;
  
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="UTF-8">
      <title>${tituloReal}</title>
      <style>
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }
        
        body {
          font-family: 'Arial', 'Helvetica', sans-serif;
          background: white;
          color: #333;
          padding: 20px;
        }
        
        /* Header simplificado */
        .header {
          display: flex;
          align-items: center;
          gap: 20px;
          margin-bottom: 25px;
          padding: 15px;
          background: #f8f8f8;
          border: 1px solid #ddd;
        }
        
        .logo {
          height: 50px;
          width: auto;
          border: 1px solid #ccc;
          padding: 3px;
          background: white;
        }
        
        .header-text h1 {
          font-size: 18px;
          color: #000;
          margin-bottom: 3px;
        }
        
        .header-text p {
          font-size: 11px;
          color: #666;
        }
        
        .titulo {
          font-size: 16px;
          font-weight: bold;
          color: #000;
          margin-bottom: 10px;
          padding-bottom: 5px;
          border-bottom: 2px solid #000;
        }
        
        .fecha {
          font-size: 11px;
          color: #666;
          margin-bottom: 15px;
        }
        
        table {
          width: 100%;
          border-collapse: collapse;
          font-size: 10px;
          border: 1px solid #ddd;
        }
        
        th {
          background: #333;
          color: white;
          padding: 8px 5px;
          text-align: left;
          font-size: 9px;
          text-transform: uppercase;
        }
        
        td {
          padding: 6px 5px;
          border-bottom: 1px solid #eee;
        }
        
        .activo {
          background: #f8f8f8;
        }
        
        .inactivo {
          background: #f0f0f0;
        }
        
        .total-row {
          font-weight: bold;
          background: #e0e0e0;
        }
        
        .fuente-badge {
          display: inline-block;
          padding: 2px 6px;
          background: #f0f0f0;
          border: 1px solid #ccc;
          font-size: 8px;
        }
        
        .footer {
          margin-top: 20px;
          text-align: center;
          font-size: 8px;
          color: #666;
          padding-top: 10px;
          border-top: 1px solid #ddd;
        }
        
        .no-print {
          text-align: center;
          margin-top: 20px;
        }
        
        .btn {
          padding: 8px 20px;
          font-size: 11px;
          font-weight: bold;
          text-transform: uppercase;
          cursor: pointer;
          border: 1px solid;
        }
        
        .btn-imprimir {
          background: #333;
          color: white;
          border-color: #333;
        }
        
        .btn-cerrar {
          background: white;
          color: #333;
          border-color: #ccc;
          margin-left: 10px;
        }
        
        @media print {
          body { padding: 0; }
          .no-print { display: none; }
          @page { margin: 1cm; }
        }
      </style>
    </head>
    <body>
      <div class="header">
        <img src="data:image/jpeg;base64,${getLogoBase64()}" 
             alt="Logo" 
             class="logo"
             onerror="this.style.display='none'">
        <div class="header-text">
          <h1>${SYSTEM_JJ_CONFIG.nombre}</h1>
          <p>${SYSTEM_JJ_CONFIG.slogan}</p>
        </div>
      </div>
      
      <div class="titulo">${tituloReal}</div>
      <div class="fecha">Generado: ${formatearFechaReporte(fechaActual.toISOString())}</div>
      
      <table>
        <thead>
          <tr>
            <th>Fecha</th>
            <th>Fuente</th>
            <th>Precio (Bs)</th>
            ${tipo === 'venta' ? '<th>Tasa Inversa</th>' : ''}
            <th>Estado</th>
            <th>Obs.</th>
          </tr>
        </thead>
        <tbody>
          ${tasas.map(tasa => {
            const precio = tipo === 'compra' ? tasa.precio_usdt_bs : tasa.precio_usd_bs;
            return `
              <tr class="${tasa.activa ? 'activo' : 'inactivo'}">
                <td>${formatearFechaCorta(tasa.fecha)}</td>
                <td><span class="fuente-badge">${tasa.nombreFuente || 'N/A'}</span></td>
                <td align="right"><strong>${formatearMonto(precio)}</strong></td>
                ${tipo === 'venta' ? `<td align="right">${formatearMonto(1 / precio, 4)}</td>` : ''}
                <td>${convertirEstadoTexto(tasa.activa)}</td>
                <td>${tasa.observaciones ? '✓' : '—'}</td>
              </tr>
            `;
          }).join('')}
        </tbody>
        <tfoot>
          <tr class="total-row">
            <td colspan="${tipo === 'venta' ? 6 : 5}" align="right">
              Total: ${tasas.length} | Activas: ${activas} | Inactivas: ${inactivas}
            </td>
          </tr>
        </tfoot>
      </table>
      
      <div class="footer">
        ${SYSTEM_JJ_CONFIG.direccion} - Tel: ${SYSTEM_JJ_CONFIG.telefono}<br>
        RIF ${SYSTEM_JJ_CONFIG.rif} - ${SYSTEM_JJ_CONFIG.email}
      </div>
      
      <div class="no-print">
        <button class="btn btn-imprimir" onclick="window.print()">IMPRIMIR</button>
        <button class="btn btn-cerrar" onclick="window.close()">CERRAR</button>
      </div>
    </body>
    </html>
  `;
};

// Funciones de impresión (automáticas)
export const imprimirReporteTasas = async (tasas, tipo = 'compra', titulo = null, filtros = {}) => {
  if (!tasas || tasas.length === 0) {
    alert('No hay tasas para mostrar');
    return false;
  }
  
  try {
    const htmlReporte = generarHTMLReporteTasas(tasas, tipo, titulo, filtros);
    const ventana = window.open('', '_blank', 'width=1300,height=800,menubar=yes,toolbar=yes,location=yes,status=yes,scrollbars=yes');
    
    if (!ventana) {
      alert('Permite ventanas emergentes');
      return false;
    }
    
    ventana.document.write(htmlReporte);
    ventana.document.close();
    ventana.focus();
    return true;
  } catch (error) {
    console.error('Error:', error);
    alert('Error al generar el reporte');
    return false;
  }
};

export const imprimirReporteTasasSimplificado = async (tasas, tipo = 'compra', titulo = null) => {
  if (!tasas || tasas.length === 0) {
    alert('No hay tasas para mostrar');
    return false;
  }
  
  try {
    const htmlReporte = generarHTMLReporteSimplificado(tasas, tipo, titulo);
    const ventana = window.open('', '_blank', 'width=1200,height=700,menubar=yes,toolbar=yes,location=yes,status=yes');
    
    if (!ventana) {
      alert('Permite ventanas emergentes');
      return false;
    }
    
    ventana.document.write(htmlReporte);
    ventana.document.close();
    ventana.focus();
    return true;
  } catch (error) {
    console.error('Error:', error);
    alert('Error al generar el reporte');
    return false;
  }
};

export default {
  SYSTEM_JJ_CONFIG,
  cargarLogo,
  getLogoBase64,
  formatearFechaReporte,
  formatearFechaCorta,
  formatearMonto,
  convertirEstadoTexto,
  calcularEstadisticasReporte,
  generarHTMLReporteTasas,
  imprimirReporteTasas,
  generarHTMLReporteSimplificado,
  imprimirReporteTasasSimplificado
};